<template>
  <div id="sentiments_amd">
    <div data-html2canvas-ignore="true" v-show="loader || sentimentLoader || bulkLoader">
      <Loader />
    </div>
    <div class="card datepickerwrap" style="flex-direction: row">
      <div class="leftcontent wrapitem d-flex">
        <div class="custom_dropdown customMultiselect mr-3" style="width:35%">
          <multiselect v-model="getSelectedWebsites" :options="websiteMenuItems" :multiple="true" group-values="options"
            group-label="optgroup" :group-select="true" placeholder="Search Website(s)" track-by="key" label="label"
            select-label="" deselect-label="" selectedLabel="" :closeOnSelect="false" selectGroupLabel="Select Group"
            deselectGroupLabel="Deselect Group" @select="setSelectedWebsites($event)"
            @remove="removeSelectedWebsites($event)">
            <template slot="option" slot-scope="{ option }">
              <div v-if="option.$isLabel"><strong>{{ option.$groupLabel }}</strong></div>
              <div v-else>
                <input type="checkbox" :value="option" v-model="getSelectedWebsites">
                <span class="option__title ml-3">{{ option.label }}</span>
              </div>
            </template>
          </multiselect>
        </div>
        <div class="datebox" style="width: 10% !important;">
          <button class="btn primarycolor" @click="clearBrandStorage">Reset</button>
        </div>
        <div class="datebox">
          <select v-model="device" @change="siteDeviceChange" class="form-control text-uppercase">
            <option v-if="!selected_website_array.every((website) =>
              onlyCpuGpuSites.includes(website)
            )
              " value="laptop">
              Laptop
            </option>
            <option v-if="!selected_website_array.every((website) =>
              onlyCpuGpuSites.includes(website)
            )
              " value="desktop">
              Desktop
            </option>
            <option v-if="selected_website_array.some((website) => cpuGpuSites.includes(website))
              " value="gpu">
              GPU
            </option>
            <option v-if="selected_website_array.some((website) => cpuGpuSites.includes(website))
              " value="cpu">
              CPU
            </option>
          </select>
        </div>
        <div class="datebox" style="width: 12% !important">
          <button @click="siteDeviceChange" class="btn primarycolor" type="button">
            <span>Submit</span>
          </button>
        </div>
        <div class="datebox custom_dropdown">
          <div @click="showProductModal" class="custom_dropdown_wrap" style="
              background: white;
              padding-left: 14px;
              border: 1px solid var(--base_color-40);
              border-radius: 5px;
              margin-left: -5px;
              padding-right: 14px;
              height: 2.2rem;
            ">

            <span class="custom_dropdown_title" style="
                margin-top: 0px;
                float: left;
                font-size: 12px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 201px;
              ">{{ allReviewProductsCheck ? "All" : selectedProduct[0] }} &nbsp;</span>
            <i style="font-size: 17px" class="fa fa-angle-down"></i>
          </div>
        </div>
        <div class="datebox">
          <datepicker placeholder="From" @input="refreshReview" v-model="reviewStartDate" />
        </div>
        <div class="datebox">
          <datepicker v-model="reviewEndDate" class="picker-left" placeholder="To" @input="refreshReview" />
        </div>
      </div>
      <div class="righcontent wrapitem">
        <button @click="backToSov" style="float: right" class="btn navigationButton" type="button">
          <img src="Icons_SVG/Arrow_Left.svg" height="16" class="backIcon" style="margin-top: -3px" />
          <span style="font-size: 16px"> Back</span>
        </button>
      </div>
    </div>
    <div class="daterpickerwrap">
      <div class="">
        <div v-if="allReviewProductsCheck || checkedReviewsProducts.length > 1">
          <div style="display: flex">
            <div class="card w-50" style="margin: 10px; height: 100%">
              <h4 style="max-width: 50%; margin-bottom: 0px !important" class="graphHeading">
                Reviews and Rating
              </h4>
            </div>
            <div class="card w-50" style="margin: 10px; height: 100%">
              <h4 style="max-width: 50%; margin-bottom: 0px !important" class="graphHeading">
                Sentiments
              </h4>
            </div>
          </div>
          <div style="display: flex">
            <div style="margin: 10px; height: 100%; min-width: 49%; max-width: 50%">
              <div v-for="item in reviewStarData" :key="item[0].processor_type">
                <div class="card" style="height: 600px; overflow-y: auto"
                  :style="{ height: !item[0].count ? '100%' : '600px' }">
                  <div class="space-between-header" style="border: none !important">
                    <h4 style="max-width: 50%; margin-bottom: 0px !important" class="graphHeading">
                      {{ item[0].processor_type }}
                    </h4>
                  </div>
                  <div v-if="!item[0].count">No data</div>
                  <div v-if="item[0].count" no-body>
                    <div class="pb-0 d-flex justify-content-center align-items-center justify-content-stretch mb-3 mt-2">
                      <div class="d-flex flex-column align-items-center w-30 mx-2 px-5"
                        style="border-right: 0.13rem solid #e1e1e1 !important">
                        <h4 class="mb-0" style="color: var(--green); font-size: 2rem; font-weight: 600">
                          <span>{{ item[0].count | format }} </span>
                        </h4>
                        <p class="text-capitalize" style="
                            color: var(--primary_brand);
                            font-size: 1rem;
                            margin-top: 30px;
                          ">
                          Total Reviews
                        </p>
                      </div>
                      <div class="d-flex flex-column align-items-center justify-content-stretch w-30 mx-2 px-5"
                        style="border-right: 0.13rem solid #e1e1e1 !important">
                        <h4 class="mb-0" style="color: var(--green); font-size: 2rem; font-weight: 600">
                          <span>{{ item[0].review_avg | format }} </span>
                        </h4>
                        <p class="text-capitalize" style="
                            color: var(--primary_brand);
                            font-size: 1rem;
                            margin-top: 30px;
                          ">
                          Total Ratings
                        </p>
                      </div>
                      <div class="d-flex flex-column align-items-center w-30 mx-5">
                        <highcharts style="
                            width: fit-content;
                            height: 70px;
                            margin: auto;
                            margin-bottom: 6px;
                          " :options="sentimentChart[item[0].processor_type]"></highcharts>
                        <p class="text-capitalize" style="color: var(--primary_brand); font-size: 1rem">
                          Score
                        </p>
                      </div>
                    </div>
                  </div>

                  <div v-if="item[0].count">
                    <h5 class="text-capitalize mb-2">
                      <span style="
                          max-width: 82%;
                          display: inline-block;
                          color: var(--primary_brand);
                        ">
                      </span>
                    </h5>
                    <div class="borderBetween"></div>
                    <div class="progress-group" :key="r + i" v-for="(r, i) in item[0].ratings">
                      <div class="progress-group-header">
                        <i class="fa fa-star text-star-color" :key="s + j" v-for="(s, j) in r.rating"></i>
                        <span class="ml-auto" style="margin-bottom: -0.3rem">
                          {{ r.count | format }}
                          <span class="text-muted small">({{ r.per | format }}%)</span>
                        </span>
                      </div>
                      <div class="progress-group-bars" style="margin-top: 0.2rem">
                        <div class="progress progress-xs" style="height: 0.5rem">
                          <div role="progressbar" class="progress-bar"
                            style="background-color: var(--green-80); border-radius: 1rem"
                            :style="'width:' + r.per + '%'"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin: 10px; height: 100%; min-width: 48.7%; max-width: 49%">
              <div v-for="item in sentimentData" :key="item.processor_type">
                <div class="card" style="height: 600px; overflow-y: scroll"
                  :style="{ height: !item.data.length ? '100%' : '600px' }">
                  <div class="space-between-header" style="border: none !important">
                    <h4 style="max-width: 50%; margin-bottom: 0px !important" class="graphHeading">
                      {{ item.processor_type }}
                    </h4>
                  </div>
                  <div v-if="!item.data.length">No data</div>
                  <div class="mt-1" v-if="item.data.length" no-body>
                    <table class="table table-sm">
                      <thead>
                        <tr>
                          <th scope="col">Keyword</th>
                          <th scope="col">Positive Frequency</th>
                          <th scope="col">Negative Frequency</th>
                          <th scope="col">Total Frequency</th>
                          <th scope="col">Average Rating</th>
                          <th scope="col">Score</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="d in item.data" :key="d.word">
                          <td>
                            <span @click="openGenKeywordModal(d.word, item.processor_type)"
                              style="color: #20a8d8; cursor: pointer">
                              {{ d.word }}</span>
                          </td>
                          <td>
                            <div style="color: var(--green)">
                              {{ d.positive_frequency }}
                            </div>
                          </td>
                          <td>
                            <div style="color: var(--red)">
                              {{ d.negative_frequency }}
                            </div>
                          </td>
                          <td>
                            <div>{{ d.positive_frequency + d.negative_frequency }}</div>
                          </td>
                          <td>
                            <div>{{ d.average_rating }}</div>
                          </td>
                          <td>
                            <div>
                              <div>
                                <highcharts style="
                                    width: fit-content;
                                    height: 88px;
                                    margin: auto;
                                    margin-top: 7px;
                                  " :options="sentimentChart[d.word]"></highcharts>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!allReviewProductsCheck && checkedReviewsProducts.length === 1" style="display: flex">
          <div class="card w-50" style="margin: 10px; height: 700px; overflow-y: auto">
            <div class="space-between-header" style="border: none !important">
              <h4 style="max-width: 50%; margin-bottom: 0px !important" class="graphHeading">
                Reviews and Rating
              </h4>
            </div>
            <div v-if="reviewStarData.length" no-body>
              <div class="pb-0 d-flex justify-content-start align-items-center mb-3 mt-2">
                <div class="d-flex flex-column align-items-center" style="
                    margin-left: 16%;
                    border-right: 0.13rem solid #e1e1e1 !important;
                    padding-right: 16%;
                  ">
                  <h4 class="mb-0" style="color: var(--green); font-size: 2rem; font-weight: 600">
                    <span>{{ reviewStarData[0].count | format }} </span>
                  </h4>
                  <p class="text-capitalize" style="color: var(--primary_brand); font-size: 1rem">
                    Total Reviews
                  </p>
                </div>
                <div class="d-flex flex-column align-items-center" style="margin-left: 16%">
                  <h4 class="mb-0" style="color: var(--green); font-size: 2rem; font-weight: 600">
                    <span>{{ reviewStarData[0].review_avg | format }} </span>
                  </h4>
                  <p class="text-capitalize" style="color: var(--primary_brand); font-size: 1rem">
                    Total Ratings
                  </p>
                </div>
              </div>
            </div>

            <div v-if="reviewStarData[0]">
              <h5 class="text-capitalize mb-2">
                <span style="
                    max-width: 82%;
                    display: inline-block;
                    color: var(--primary_brand);
                  ">
                  {{ reviewStarData[0].product_name }}
                </span>
                <!-- <i class="fa fa-star text-star-color float-right"></i> -->
                <!-- <span class="float-right">{{
                  reviewStarData[0].review_avg | format
                }}</span> -->
              </h5>
              <div class="borderBetween"></div>
              <div class="progress-group" :key="r + i" v-for="(r, i) in reviewStarData[0].ratings">
                <div class="progress-group-header">
                  <i class="fa fa-star text-star-color" :key="s + j" v-for="(s, j) in r.rating"></i>
                  <span class="ml-auto" style="margin-bottom: -0.3rem">
                    {{ r.count | format }}
                    <span class="text-muted small">({{ r.per | format }}%)</span>
                  </span>
                </div>
                <div class="progress-group-bars" style="margin-top: 0.2rem">
                  <div class="progress progress-xs" style="height: 0.5rem">
                    <div role="progressbar" class="progress-bar"
                      style="background-color: var(--green-80); border-radius: 1rem" :style="'width:' + r.per + '%'">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card w-50" style="margin: 10px; height: 700px; overflow-y: auto"
            :style="{ height: !sentimentData.length ? '100%' : '700px' }">
            <div class="space-between-header" style="border: none !important">
              <h4 style="max-width: 50%; margin-bottom: 0px !important" class="graphHeading">
                Sentiments
              </h4>
            </div>
            <div v-if="sentimentData.length == 0">No data</div>
            <div class="mt-1" v-if="sentimentData.length" no-body>
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th scope="col">Keyword</th>
                    <th scope="col">Positive Frequency</th>
                    <th scope="col">Negative Frequency</th>
                    <th scope="col">Total Frequency</th>
                    <th scope="col">Average Rating</th>
                    <th scope="col">Score</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="d in sentimentData" :key="d.word">
                    <td>
                      <span @click="openModal(d.word, 'All')" style="color: #20a8d8; cursor: pointer">
                        {{ d.word }}</span>
                    </td>
                    <td>
                      <div style="color: var(--green)">{{ d.positive_frequency }}</div>
                    </td>
                    <td>
                      <div style="color: var(--red)">{{ d.negative_frequency }}</div>
                    </td>
                    <td>
                      <div>{{ d.positive_frequency + d.negative_frequency }}</div>
                    </td>
                    <td>
                      <div>{{ d.average_rating }}</div>
                    </td>
                    <td>
                      <div>
                        <div>
                          <highcharts style="
                              width: fit-content;
                              height: 88px;
                              margin: auto;
                              margin-top: 7px;
                            " :options="sentimentChart[d.word]"></highcharts>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal size="xl" :title="'Keyword - ' + modalTitle" v-model="showAllModal">
      <div class="customdim" v-show="modalLoader">
        <Loader />
      </div>
      <div class="leftcontent wrapitem">
        <div class="datebox">
          <datepicker placeholder="From" v-model="reviewStartDate" />
        </div>
        <div class="datebox">
          <datepicker v-model="reviewEndDate" class="picker-left" placeholder="To" />
        </div>
        <div class="datebox">
          <button @click="refreshModal" class="btn primarycolor" type="button">
            Submit
          </button>
        </div>
      </div>
      <b-card style="margin-top: 10px">
        <div>
          <h4 style="
              display: inline-block;
              padding-top: 10px;
              text-transform: capitalize;
              font-family: 'Poppins', sans-serif;
              color: var(--primary_brand);
            ">
            {{ chartDataMapper[chartDataKey] }}
          </h4>
          <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
            <b-form-radio-group class="mr-3 radiohide" id="radiosBtn" buttons button-variant="outline-secondary"
              @change="getKeywordChartData" v-model="interval" name="radiosBtn">
              <b-form-radio class="mx-0" value="month">Month</b-form-radio>
              <b-form-radio class="mx-0" value="week">Week</b-form-radio>
            </b-form-radio-group>
          </b-button-toolbar>
          <span class="float-right" style="margin-right: 10px">
            <select class="form-control customSelect" @change="processChartData" v-model="chartDataKey">
              <option value="original_frequency">Frequency</option>
              <option value="original_score">Score</option>
              <option value="reviews_count">Review Count</option>
            </select>
          </span>
        </div>
        <highcharts :options="modalChart" v-if="activeModalChart" style="margin-top: 10px"></highcharts>
        <highcharts :options="cmodalChart" v-if="activeModalChart" style="margin-top: 10px"></highcharts>
        <div v-if="!activeModalChart">No data</div>
      </b-card>
      <div class="d-flex justify-content-between">
        <div class="datebox" style="width: unset !important">
          <button :class="{ highlight_primary: allModalSentimentType == 'All' }" @click="changeAllSentimentType('All')"
            class="btn primarycolor" style="margin-right: 5px">
            All
          </button>
          <button :class="{ highlight_success: allModalSentimentType == 'positive' }"
            @click="changeAllSentimentType('positive')" class="btn success" style="margin-right: 5px">
            Positive
          </button>
          <button :class="{ highlight_danger: allModalSentimentType == 'negative' }"
            @click="changeAllSentimentType('negative')" class="btn danger" style="margin-right: 5px">
            Negative
          </button>
        </div>
        <div class="d-flex align-items-center" style="font: 14px Poppins, sans-serif">
          <div class="mr-2">
            <i class="fa fa-square" style="
                color: var(--blue-20) !important;
                border-radius: 2px;
                margin-right: 2px;
              "></i>
            <span>Channel</span>
          </div>
          <div class="mr-2">
            <i class="fa fa-square" style="
                color: var(--accent_color-20) !important;
                border-radius: 2px;
                margin-right: 2px;
              "></i>
            <span>Processor Type</span>
          </div>
          <div>
            <i class="fa fa-square" style="
                color: var(--pink-20) !important;
                border-radius: 2px;
                margin-right: 2px;
              "></i>
            <span>Processor Model</span>
          </div>
        </div>
      </div>
      <div class="reviews-panel" style="height: 500px; overflow-y: scroll">
        <div v-for="d in allKeywordData.data" :key="d" class="each-review">
          <div class="usericon">
            <img src="Icons_SVG/User.svg" />
          </div>
          <div class="username">
            {{ d.person_name }}
          </div>
          <div class="usertimestamp">
            {{ d.review_date }}
          </div>
          <div class="helpful">
            Helpful: {{ d.found_helpful }}
            <a :href="d.review_link" target="_blank"> Link </a>
          </div>
          <div style="display: inline-block; width: 100%">
            <div class="d-flex justify-content-between">
              <div class="d-flex w-75" style="
                  color: var(--primary_brand);
                  font: 600 14px Heebo, sans-serif;
                  letter-spacing: 0.6px;
                ">
                {{ d.product_name }}
              </div>
              <div class="d-flex justify-content-end" style="width: 25%; height: 70%">
                <div style="
                    margin: 0 0.2rem 0.3rem 0;
                    padding: 0.2rem 0.6rem;
                    background-color: var(--blue-20);
                    border-radius: 6px;
                    text-transform: capitalize;
                    min-width: 35px;
                  ">
                  {{ d._channel.replace('_', ' ') }}
                </div>
                <div style="
                    margin: 0 0.2rem 0.3rem 0;
                    padding: 0.2rem 0.6rem;
                    background-color: var(--accent_color-20);
                    border-radius: 6px;
                    text-transform: capitalize;
                    min-width: 35px;
                  ">
                  {{
                    d.processor_type.toLowerCase().replace("amd", "AMD").replace("#", "")
                  }}
                </div>
                <div style="
                    margin: 0 0 0.3rem 0;
                    padding: 0.2rem 0.6rem;
                    background-color: var(--pink-20);
                    border-radius: 6px;
                    text-transform: capitalize;
                  ">
                  {{ d.processor_model }}
                </div>
              </div>
            </div>
          </div>
          <div class="usertext">
            <text-highlight :queries="modalTitle.toLowerCase()" :highlightStyle="{
              'background-color': 'white',
              color: 'var(--blue)',
              'font-weight': '400',
              padding: '0',
            }">{{ d.review.replaceAll("#", "") }}</text-highlight>
          </div>
          <hr style="margin-block: 0.2rem !important" />
        </div>
      </div>
    </b-modal>
    <b-modal size="lg" title="Select  " v-model="isProductModal" class="customModal">
      <b-row>
        <div class="col-md-12">
          <div style="display: flex" class="searchInput">
            <input style="border-radius: 0; padding: 6px; font-size: 11px" class="form-control" v-model="schProduct"
              type="text" placeholder="Search" />
            <div class="searchIcon">
              <img src="Icons_SVG/Search.svg" />
            </div>
          </div>
        </div>
      </b-row>
      <b-row class="pt-2">
        <div class="col-md-12 mb-1" v-if="checkChannel()">
          <div class="row">
            <div class="col-md-2">
              <p class="mt-1 inputBoxTitle">OEM:</p>
            </div>
            <div class="col-md-10 customMultiselect">
              <multiselect v-model="checkedOemReviewsBrands" :options="filterKeys.brand.map(data => {
                return { label: data }
              })" @input="changeFilter" :searchable="false" placeholder="Select Brand(s)" selectLabel=""
                track-by="label" label="label" :multiple="true" />
            </div>
          </div>
        </div>
        <div class="col-md-12 mb-1">
          <div class="row">
            <div class="col-md-2">
              <p class="mt-1 inputBoxTitle">Processor:</p>
            </div>
            <div class="col-md-10 customMultiselect">
              <multiselect v-model="checkedReviewsProcessors" :options="filterKeys.processor_type.map(data => {
                return { label: data }
              })" @input="changeFilter" :searchable="false" placeholder="Select Processor(s)" selectLabel=""
                track-by="label" label="label" :multiple="true" />
            </div>
          </div>
        </div>
      </b-row>
      <b-row>
        <div class="col-md-12 mb-1">
          <div class="row">
            <div class="col-md-1">
              <p class="inputBoxTitle">Ratings:</p>
            </div>
            <div class="col-md-1"></div>
            <div class="col-md-3">
              <select v-model="ratingExp" class="form-control text-uppercase modalSelect">
                <option value="eq">Equals to (=)</option>
                <option value="gt">Greater than (&gt;)</option>
                <option value="gte">Greater than equals to (&gt;=)</option>
                <option value="lt">Lower than</option>
                <option value="lte">Lower than equals to (&lt;=)</option>
                <option value="between">Between (&gt;= &amp;&amp; &lt;=)</option>
              </select>
            </div>
            <div class="col-md-2 pl-0">
              <input min="0" max="5" v-model="ratingInput1" style="border: 1px solid silver !important"
                class="form-control filval modalSelect" type="number" placeholder="Enter Value" />
            </div>
            <div v-if="ratingExp == 'between'" class="col-md-2 pl-0">
              <input min="0" max="5" v-model="ratingInput2" style="border: 1px solid silver !important"
                class="form-control filval modalSelect" type="number" placeholder="Enter Value" />
            </div>
            <div class="col-md-3 pl-0">
              <button @click="applyRatingFilter" class="btn primarycolor mr-1">
                Apply
              </button>
              <button @click="removeRatingFilter" class="btn primarycolor" style="
                  background-color: var(--red);
                  padding-right: 7px;
                  padding-left: 7px;
                ">
                Remove
              </button>
            </div>
          </div>
        </div>
      </b-row>
      <b-row style="margin-top: 15px; padding-right: 5px">
        <div class="col-md-3 pr-0">
          <div class="checkbox-btn">
            <input @change="changeFilter" v-model="fourKSeries" type="checkbox"
              style="float: left; margin-right: 6px; margin-top: 3px" />
            <span>4000 Series</span>
          </div>
        </div>
        <div class="col-md-3 pl-1 pr-0">
          <div class="checkbox-btn">
            <input @change="changeFilter" v-model="fiveKSeries" type="checkbox"
              style="float: left; margin-right: 6px; margin-top: 3px" />
            <span>5000 Series</span>
          </div>
        </div>
        <div class="col-md-3 pl-1 pr-0">
          <div class="checkbox-btn">
            <input @change="changeFilter" v-model="sixKSeries" type="checkbox"
              style="float: left; margin-right: 6px; margin-top: 3px" />
            <span>6000 Series</span>
          </div>
        </div>
        <div class="col-md-3 pl-1 pr-0">
          <div class="checkbox-btn">
            <input @change="changeFilter" v-model="sevenSeries" type="checkbox"
              style="float: left; margin-right: 6px; margin-top: 3px" />
            <span>7000 Series</span>
          </div>
        </div>
      </b-row>

      <div class="space-between-header" style="padding-top: 20px; align-items: center">
        <h6 class="m-0 graphHeading" style="margin-bottom: 0px !important">Products:</h6>
        <button class="btn primarycolor" @click="selectProductNow()">Apply</button>
      </div>
      <div class="productScroll">
        <div class="eachProduct productListCheckbox" style="padding: 4px">
          <div style="width: 20px; height: 20px; margin-right: 10px;">
            <input type="checkbox" class="mr-1 mt-1" style="margin-left: 2.3px;" value="all"
              @click="processAllProductChecking($event)" v-model="allReviewProductsCheck" />
          </div>
          <div>All</div>
        </div>
        <div :class="{ selectedProduct: selectedProduct.key == d.key }" v-if="checkSearchFilter(d.key)"
          class="eachProduct productListCheckbox" style="padding: 6px; font-family: 'Poppins', sans-serif !important"
          :key="d.key + idx" v-for="d, idx of productOptions">
          <div style="width: 20px; height: 20px; margin-right: 10px;">
            <input type="checkbox" class="mr-1" :value="d.key" @click="processProductChecking($event)" :checked="allReviewProductsCheck ? true : checkedReviewsProducts.includes(d.key)
              " />
          </div>
          <div v-if="d.key !== 'All'" style="
              color: white;
              background: #548f92;
              margin-right: 10px;
              padding: 4px;
              border-radius: 5px;
              text-align: center;
              text-transform: uppercase;
            ">{{ d.channel.replace("_", " ") }}</div>
          <div>{{ d.key }}</div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import TextHighlight from "vue-text-highlight";
import Multiselect from "vue-multiselect"
import Loader from "./Components/Loader.vue"

export default {
  name: "sov",
  components: { Datepicker, TextHighlight, Multiselect, Loader },
  data: function () {
    return {
      selected_SOVWebsite: localStorage.selected_SOVWebsite,
      selectedWebsites: [],
      websiteMenuItems: [
        {
          optgroup: "RETAIL",
          options: [
            { key: "https://www.amazon.com", label: "Amazon US", channel: "amazon_US" },
            { key: "https://www.amazon.fr", label: "Amazon France", channel: "amazon_france" },
            { key: "https://www.amazon.co.it", label: "Amazon Italy", channel: "amazon_italy" },
            { key: "https://www.amazon.es", label: "Amazon Spain", channel: "amazon_spain" },
            { key: "https://www.amazon.co.uk", label: "Amazon UK", channel: "amazon_uk" },
            { key: "https://www.amazon.de", label: "Amazon Germany", channel: "amazon_germany" },
            { key: "https://www.bestbuy.com", label: "Best Buy US", channel: "BESTBUY" },
            { key: "https://www.newegg.com", label: "Newegg", channel: "newegg" },
            { key: "https://www.microcenter.com", label: "Microcenter", channel: "microcenter" },
            { key: "https://www.costco.com", label: "Costco US", channel: "costco" },
            { key: "https://www.currys.co.uk", label: "Curry's UK", channel: "currys_uk" },
            { key: "https://www.harveynorman.com.au", label: "Harvey Norman AU", channel: "harvey" },
            { key: "https://global.jd.com", label: "JD GC", channel: "jd" },
            { key: "https://www.mediamarkt.de", label: "MediaMarkt DE", channel: "mediamarkt" },
            { key: "https://www.walmart.com", label: "Walmart US", channel: "walmart" },
          ],
        },
        {
          optgroup: "CONSUMER OEM",
          options: [
            { key: "https://br-store.acer.com", label: "Acer Brazil", channel: "acer_brazil" },
            { key: "https://store.acer.com/en-us", label: "Acer US", channel: "Acer" },
            { key: "https://store.asus.com/us", label: "ASUS US", channel: "asus" },
            { key: "https://www.asus.com/fr", label: "ASUS France", channel: "asus_france" },
            { key: "https://www.dell.com/en-au", label: "Dell Australia", channel: "dell_australia" },
            { key: "https://www.dell.com/ja-jp", label: "Dell Japan", channel: "dell_japan" },
            { key: "https://www.dell.com/en-us", label: "Dell US", channel: "dell" },
            { key: "https://www.dell.com/en-uk", label: "Dell UK", channel: "dell_uk" },
            { key: "https://store.hp.com/FranceStore", label: "HP France", channel: "hp_france" },
            { key: "https://www8.hp.com/jp", label: "HP Japan", channel: "hp_japan" },
            { key: "https://store.hp.com/mx-es", label: "HP Mexico", channel: "hp_mexico" },
            { key: "https://store.hp.com/UKStore", label: "HP UK", channel: "hp_uk" },
            { key: "https://store.hp.com/us", label: "HP US", channel: "hp" },
            { key: "https://www.lenovo.com/au", label: "Lenovo Australia", channel: "lenovo_australia" },
            { key: "https://www.lenovo.com/fr", label: "Lenovo France", channel: "lenovo_france" },
            { key: "https://www.lenovo.com/de", label: "Lenovo Germany", channel: "lenovo_germany" },
            { key: "https://www.lenovo.com/gb", label: "Lenovo UK", channel: "lenovo_uk" },
            { key: "https://www.lenovo.com/us", label: "Lenovo US", channel: "lenovo" },
          ],
        },
        {
          optgroup: "COMMERCIAL OEM",
          options: [
            {
              key: "https://store.hp.com/FranceStore#commercial", label: "Commercial HP France", channel: "hp_france_commercial"
            },
            {
              key: "https://store.hp.com/GermanyStore#commercial", label: "Commercial HP Germany", channel: "hp_germany"
            },
            {
              key: "https://store.hp.com/UKStore#commercial", label: "Commercial HP UK", channel: "hp_uk_commercial",
            },
            {
              key: "https://store.hp.com/us#commercial", label: "Commercial HP US",
              channel: "hp_commercial",
            },
            {
              key: "https://www.lenovo.com/fr#commercial", label: "Commercial Lenovo France",
              channel: "lenovo_france_commercial",
            },
            {
              key: "https://www.lenovo.com/de#commercial", label: "Commercial Lenovo Germany",
              channel: "lenovo_germany_commercial",
            },
            {
              key: "https://www.lenovo.com/jp#commercial", label: "Commercial Lenovo Japan",
              channel: "lenovo_japan_commercial",
            },
            {
              key: "https://www.lenovo.com/gb#commercial", label: "Commercial Lenovo UK",
              channel: "lenovo_uk_commercial",
            },
            {
              key: "https://www.lenovo.com/us#commercial", label: "Commercial Lenovo US",
              channel: "lenovo_commercial",
            },
          ],
        },
        {
          optgroup: "COMMERCIAL RESELLER",
          options: [
            { key: "https://www.bechtle.com", label: "Bechtle", channel: "bechtle" },
            { key: "https://www.cdw.com", label: "CDW", channel: "cdw" },
            { key: "https://www.inmac-wstore.com", label: "Inmac", channel: "inmac" },
            { key: "https://www.insight.com/en-US", label: "Insight", channel: "insight" },
            { key: "https://www.connection.com", label: "PC Connection", channel: "pc_connection" },
            { key: "https://www.shi.com", label: "SHI", channel: "shi" },
            { key: "https://www.technoworld.com", label: "TechnoWorld", channel: "technoworld" },
          ],
        },
      ],
      cpuGpuSites: [
        "https://www.amazon.com",
        "https://www.microcenter.com",
        "https://www.newegg.com",
        "https://www.bestbuy.com",
      ],
      onlyCpuGpuSites: ["https://www.newegg.com", "https://www.microcenter.com"],
      selected_website_array: [],
      selected_website_channel_array: [],
      selected_channel: "",
      reviewStarData: [],
      sentimentData: {},
      sentimentChart: {},
      reviewsChart: {},
      activeSentimentChart: false,
      selectedProduct: {},
      productOptions: [],
      reviewStartDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
      reviewEndDate: moment().format("YYYY-MM-DD"),
      loader: true,
      modalTitle: "",
      modalSentimentType: "All",
      allModalSentimentType: "All",
      keywordChartData: {},
      allKeywordData: [],
      showModal: false,
      showAllModal: false,
      modalLoader: false,
      chartDataKey: "original_frequency",
      chartDataMapper: {
        original_score: "Score",
        original_frequency: "Frequency",
        reviews_count: "Reviews Count",
      },
      interval: "month",
      activeModalChart: false,
      modalData: {},
      isProductModal: false,
      schProduct: "",
      deviceMapper: {
        laptop: "PC",
        desktop: "Desktop",
      },
      device: localStorage.selected_category,
      ratingInput1: "",
      ratingExp: "eq",
      ratingInput2: "",
      pickProduct: false,
      filterChanged: false,
      cpuFilter: "",
      brandFilter: "",
      filterKeys: {
        brand: [],
        processor_type: [],
      },
      reviewsRatingExp: "eq",
      reviewsRatingInput: "",
      reviewsRatingInput2: "",
      reviewsData: {},
      updateSelectedProduct: false,
      fourKSeries: false,
      fiveKSeries: false,
      sixKSeries: false,
      sevenSeries: false,
      allModalProduct: false,
      processorModel: "",
      modifiedSelectedWebsites: [],
      checkedOemReviewsBrands: [],
      checkedReviewsProducts: [],
      checkedReviewsProcessors: [],
      allReviewProductsCheck: true,
      bulkLoader: false,
      sentimentLoader: false
    };
  },
  watch: {
    revInterval: function () {
      if (this.selectedProduct.key) this.getReviews();
    },
  },
  computed: {
    getSelectedWebsites: {
      get() {
        return this.selectedWebsites;
      },
      set() {
        this.selectedWebsites = this.modifiedSelectedWebsites;
      }
    }
  },
  mounted() {
    localStorage.removeItem("comp_check")
    if (localStorage.selected_SOVWebsite) {
      if (localStorage.selected_websites) {
        this.selectedWebsites = JSON.parse(localStorage.selected_websites);
        this.modifiedSelectedWebsites = JSON.parse(localStorage.selected_websites);
      } else {
        this.websiteMenuItems.map(dataset => {
          dataset.options.forEach(option => {
            if (localStorage.selected_SOVWebsite === option.key) {
              this.selectedWebsites.push(option);
              this.modifiedSelectedWebsites.push(option);
            };
          });
        });
      }
      this.getSelectedWebsites.forEach(websiteItems => {
        this.selected_website_array.push(websiteItems.key)
        this.selected_website_channel_array.push(websiteItems.channel)
      });
      this.device = localStorage.selected_category;
    } else {
      this.device = "laptop";
      this.selectedWebsites = this.websiteMenuItems[0].options[0]
      this.modifiedSelectedWebsites = this.websiteMenuItems[0].options[0]
    }

    if (localStorage.checkedOemReviewsBrands)
      this.checkedOemReviewsBrands = JSON.parse(localStorage.checkedOemReviewsBrands);
    if (localStorage.checkedReviewsProcessors)
      this.checkedReviewsProcessors = JSON.parse(localStorage.checkedReviewsProcessors);
    if (localStorage.checkedReviewsProducts)
      this.checkedReviewsProducts = JSON.parse(localStorage.checkedReviewsProducts);
    if (localStorage.allReviewProductsCheck)
      this.allReviewProductsCheck = JSON.parse(localStorage.allReviewProductsCheck);

    if (localStorage.cpuFilter) this.cpuFilter = JSON.parse(localStorage.cpuFilter);
    if (localStorage.brandFilter)
      this.brandFilter = JSON.parse(localStorage.brandFilter);
    if (localStorage.ratingExp) this.ratingExp = localStorage.ratingExp;
    if (localStorage.ratingInput1) this.ratingInput1 = localStorage.ratingInput1;
    if (localStorage.ratingInput2) this.ratingInput2 = localStorage.ratingInput2;
    if (localStorage.fourKSeries) this.fourKSeries = JSON.parse(localStorage.fourKSeries);
    if (localStorage.fiveKSeries) this.fiveKSeries = JSON.parse(localStorage.fiveKSeries);
    if (localStorage.sixKSeries) this.sixKSeries = JSON.parse(localStorage.sixKSeries);
    else delete localStorage.sixKSeries;
    if (localStorage.sevenSeries) this.sevenSeries = JSON.parse(localStorage.sevenSeries);
    else delete localStorage.sevenSeries;

    if (localStorage.reviewStartDate) {
      this.reviewStartDate = localStorage.reviewStartDate;
      this.reviewEndDate = localStorage.reviewEndDate;
    } else {
      this.reviewStartDate = moment().subtract(2, "month").format("YYYY-MM-DD");
      this.reviewEndDate = moment(this.date.startDate).format("YYYY-MM-DD");
    }

    if (this.allReviewProductsCheck) {
      this.selectedProduct = 'All'
    } else if (this.checkedReviewsProducts.length) {
      this.selectedProduct = this.checkedReviewsProducts[0]
    }

    this.getProducts();
    localStorage.setItem("sentiment_selected_product", "All");
  },
  methods: {
    toggleAllProduct(value) {
      localStorage.setItem("allProduct", value);
    },
    siteDeviceChange() {
      let self = this;
      if (!this.selectedWebsites.length) {
        this.$bvToast.toast(`Please select website(s) to get sentiments.`, {
          title: 'Weavr Sense',
          variant: 'danger',
          toaster: 'b-toaster-bottom-center',
          autoHideDelay: 3000,
        })
        return;
      }
      self.updateSelectedProduct = true;
      this.selected_website_array = [];
      this.selected_website_channel_array = []
      this.getSelectedWebsites.forEach(websiteItems => {
        this.selected_website_array.push(websiteItems.key);
        this.selected_website_channel_array.push(websiteItems.channel);
      })
      localStorage.selected_category = self.device;
      self.getProducts();
    },

    removeRatingFilter() {
      this.ratingInput1 = "";
      this.ratingInput2 = "";
      if (localStorage.ratingExp) delete localStorage.ratingExp;
      if (localStorage.ratingInput1) delete localStorage.ratingInput1;
      if (localStorage.ratingInput2) delete localStorage.ratingInput2;
      this.changeFilter();
    },
    applyRatingFilter() {
      let self = this;
      if (self.ratingInput1 > 5) {
        alert("Rating value should be between 0 and 5");
        return false;
      }
      if (self.ratingInput1 < 0) {
        alert("Rating value should be between 0 and 5");
        return false;
      }
      if (self.ratingExp == "between") {
        if (self.ratingInput2 > 5) {
          alert("Rating value should be between 0 and 5");
          return false;
        }
        if (self.ratingInput2 < 0) {
          alert("Rating value should be between 0 and 5");
          return false;
        }
      }
      self.changeFilter();
    },
    checkChannel() {
      const OEMWebsites = ["https://www.amazon.com", "https://www.amazon.fr", "https://www.amazon.co.it", "https://www.amazon.es", "https://www.amazon.co.uk", "https://www.amazon.de", "https://www.harveynorman.com.au", "https://www.costco.com", "https://www.walmart.com", "https://global.jd.com", "https://www.bestbuy.com", "https://www.currys.co.uk", "https://www.mediamarkt.de"]

      const hasOEMSite = this.selected_website_array.some(site => OEMWebsites.includes(site));

      if (hasOEMSite) {
        return true;
      } else {
        return false;
      }
    },
    checkSearchFilter(d) {
      let self = this;
      if (d.toLowerCase().indexOf(self.schProduct.toLowerCase()) != -1) {
        return true;
      } else {
        return false;
      }
    },
    processProductChecking: function (event) {
      this.allReviewProductsCheck = false;
      if (event.target.checked) {
        this.checkedReviewsProducts.push(event.target.value);
      } else {
        this.checkedReviewsProducts.splice(event.target.value, 1);
      }
    },
    processAllProductChecking: function (event) {
      if (event.target.checked) {
        this.checkedReviewsProducts = [];
      } else {
        this.checkedReviewsProducts = [];
      }
    },
    changeFilter() {
      this.pickProduct = false;
      this.selectedProduct = [];
      this.checkedReviewsProducts = [];
      this.allReviewProductsCheck = true;
      this.filterChanged = true;

      if (this.checkedReviewsProcessors) {
        this.cpuFilter = this.checkedReviewsProcessors.map((obj) => obj.label);
      }
      if (this.checkedOemReviewsBrands) {
        this.brandFilter = this.checkedOemReviewsBrands.map((obj) => obj.label);
      }

      localStorage.allReviewProductsCheck = JSON.stringify(this.allReviewProductsCheck);
      localStorage.selected_product = JSON.stringify(this.selectedProduct);
      localStorage.checkedReviewsProducts = JSON.stringify(this.checkedReviewsProducts);
      if (this.cpuFilter) localStorage.cpuFilter = JSON.stringify(this.cpuFilter);
      else delete localStorage.cpuFilter;
      if (this.brandFilter) localStorage.brandFilter = JSON.stringify(this.brandFilter);
      else delete localStorage.brandFilter;
      if (this.checkedReviewsProcessors)
        localStorage.checkedReviewsProcessors = JSON.stringify(
          this.checkedReviewsProcessors
        );
      else delete localStorage.checkedReviewsProcessors;
      if (this.checkedOemReviewsBrands)
        localStorage.checkedOemReviewsBrands = JSON.stringify(
          this.checkedOemReviewsBrands
        );
      else delete localStorage.checkedOemReviewsBrands;
      if (this.ratingExp) localStorage.ratingExp = this.ratingExp;
      else delete localStorage.ratingExp;
      if (this.ratingInput1) localStorage.ratingInput1 = this.ratingInput1;
      else delete localStorage.ratingInput1;
      if (this.ratingInput2) localStorage.ratingInput2 = this.ratingInput2;
      else delete localStorage.ratingInput2;
      if (this.fourKSeries) localStorage.fourKSeries = JSON.stringify(this.fourKSeries);
      else delete localStorage.fourKSeries;
      if (this.fiveKSeries) localStorage.fiveKSeries = JSON.stringify(this.fiveKSeries);
      else delete localStorage.fiveKSeries;
      if (this.sixKSeries) localStorage.sixKSeries = JSON.stringify(this.sixKSeries);
      else delete localStorage.sixKSeries;
      if (this.sevenSeries) localStorage.sevenSeries = JSON.stringify(this.sevenSeries);
      else delete localStorage.sevenSeries;

      this.filterActions();
    },
    selectProductNow() {
      let self = this;
      self.selectedProduct = this.checkedReviewsProducts;
      self.pickProduct = true;
      localStorage.selected_product = JSON.stringify(self.selectedProduct);
      localStorage.checkedReviewsProducts = JSON.stringify(self.checkedReviewsProducts);
      localStorage.allReviewProductsCheck = JSON.stringify(this.allReviewProductsCheck);
      self.refreshReview();
      self.isProductModal = false;
    },
    showProductModal() {
      let self = this;
      self.isProductModal = true;
    },
    formatDate(key, d) {
      let self = this;
      let obj = {
        day: moment(d).format("MMM DD, YY"),
        month: moment(d).format("MMM YY"),
        week: "",
      };
      if (self[key] == "week") {
        let end_date = moment(d).add(6, "days");
        let today = moment(self.reviewEndDate);
        if (end_date >= today) end_date = today;
        obj["week"] =
          moment(d).format("MMM DD, YY") + " - " + moment(end_date).format("MMM DD, YY");
      }
      return obj[this[key]];
    },
    backToSov() {
      window.location = "#/reviewslist";
    },
    getKeywordWiseData() {
      let self = this;
      self.modalLoader = true;
      self.loader = true;
      let url = "/api/reviews/keywordwise";
      let payload = {
        keyword: this.modalTitle,
        product_name: this.selectedProduct,
        channel: this.selected_website_channel_array,
        start_date: moment(this.reviewStartDate).format("YYYY-MM-DD"),
        end_date: moment(this.reviewEndDate).format("YYYY-MM-DD"),
        sentiment_type: this.modalSentimentType
      }

      

      self.$http.post(url, payload).then(
        (response) => {
          self.allKeywordData = response.body.data;
          self.modalLoader = false;
          self.loader = false;
          if (!self.showAllModal) self.showAllModal = true;
        },
        (err) => {
          self.modalLoader = false;
          self.loader = false;
          console.log(err);
        }
      );
    },

    processChartData() {
      let category = [];
      let series = [];
      let comm_series = [];
      let datakeys = [
        { key: "positive", label: "Positive", color: "#1ACF85" },
        { key: "negative", label: "Negative", color: "#FF786B" },
      ];
      let self = this;
      let new_key = "";
      let org_label = "";
      let com_label = "";
      if (this.chartDataKey == "original_frequency") {
        new_key = "frequency";
        org_label = "Frequency";
        com_label = "Cummulative Frequency";
      } else if (this.chartDataKey == "original_score") {
        new_key = "score";
        org_label = "Score";
        com_label = "Cummulative Score";
      } else {
        new_key = "cummulative_review_count";
        org_label = "Review Count";
        com_label = "Cummulative Review Count";
      }
      for (let [i, k] of datakeys.entries()) {
        if (this.keywordChartData.data[k.key]) {
          let obj = {};
          obj.name = k.label;
          obj.data = [];
          obj.color = k.color;
          let comm_obj = {};
          let format_date = "";
          comm_obj.name = k.label;
          comm_obj.data = [];
          comm_obj.color = k.color;
          for (let [idx, dataset] of this.keywordChartData.data[k.key].entries()) {
            category.push(self.formatDate("interval", dataset.date));
            obj.data.push(dataset[this.chartDataKey]);
            comm_obj.data.push(dataset[new_key]);
          }
          series.push(obj);
          comm_series.push(comm_obj);
        }
      }
      this.plotChart({ series: series, category: category }, "modalChart", org_label);
      this.plotChart(
        { series: comm_series, category: category },
        "cmodalChart",
        com_label
      );
    },
    plotChart(d, chartObj, chart_label) {
      var self = this;
      if (d.category.length) self.activeModalChart = true;
      else self.activeModalChart = false;
      this[chartObj] = {
        credits: {
          enabled: false,
        },
        chart: {
          height: 210,
        },
        title: {
          text: "",
        },
        subtitle: {
          text: "",
        },

        yAxis: {
          title: {
            text: chart_label,
          },
        },
        xAxis: {
          categories: d.category,
          crosshair: true,
          crosshair: {
            // color: "rgba(166, 215, 238)",
            width: 70,
          },
        },
        tooltip: {
          formatter: function () {
            var mytooltip = this.points[0].key + "<br/>";
            for (var i = 0; i < this.points.length; i++) {
              mytooltip +=
                '<span style="color:' + this.points[i].series.color + '">\u25CF</span> ';
              mytooltip += this.points[i].series.name;
              mytooltip += " : <b> " + self.format(this.points[i].y) + "</b> <br/>";
            }
            return mytooltip;
          },
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
          shared: true,
        },
        legend: {
          enabled: true,
          alignColumns: true,
          align: "right",
          y: 0,
          x: 0,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 35,
          margin: 15,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4,
        },
        plotOptions: {
          series: {
            lineWidth: 1.2,
            marker: {
              states: {
                hover: {
                  radiusPlus: 1.5,
                  lineWidthPlus: 1,
                },
              },
            },
          },
        },
        series: d.series,
      };
    },
    refreshModal() {
      let self = this;
      self.reviewStartDate = moment(self.reviewStartDate).format("YYYY-MM-DD");
      self.reviewEndDate = moment(self.reviewEndDate).format("YYYY-MM-DD");

      if (this.showAllModal) {
        if (!this.allReviewProductsCheck && this.checkedReviewsProducts.length > 1) {
          this.getKeywordChartData();
          this.getKeywordWiseData();
        } else {
          this.getAllKeywordData();
          this.getKeywordChartData();
        }
      } else {
        this.getKeywordChartData();
        this.getKeywordWiseData();
      }
    },
    openModal(keyword, type) {
      this.modalTitle = keyword;
      this.modalSentimentType = type;
      this.refreshModal("datecomponent");
    },
    getKeywordChartData() {
      let self = this;
      self.modalLoader = true;
      self.loader = true;
      self.$nextTick(function () {
        self.keywordChartData = {};
        let url = "/api/reviews/keywisesentdata";
        let payload = {
          interval: this.interval,
          keyword: this.modalTitle,
          start_date: moment(this.reviewStartDate).format("YYYY-MM-DD"),
          end_date: moment(this.reviewEndDate).format("YYYY-MM-DD"),
          channel: this.selected_website_channel_array,
          product_name: this.selectedProduct,
          sentiment_type: this.modalSentimentType,
          oem: false,
          item_category: this.device,
          processor_model: this.processorModel,
        }

        //modify payload if all is selected 
        if(this.allReviewProductsCheck){
          let selectedProcessorSeries = [];
  
          //if any of the filters is selected
          if (this.brandFilter.length || this.cpuFilter.length || this.ratingInput1 || this.ratingInput2 || this.fourKSeries || this.fiveKSeries || this.sixKSeries || this.sevenSeries) {

            //check brand filter
            if (this.brandFilter.length) {
              Object.assign(payload, { selected_brands: this.brandFilter })
              payload.oem = true;
              delete payload.product_name
            }
            //check processor filter
            if (this.cpuFilter.length) {
              Object.assign(payload, { selected_processors: this.cpuFilter, })
              payload.oem = true;
              delete payload.product_name
            }
            //check rating 
            if (this.ratingInput1) {
              Object.assign(payload, { rating_exp: this.ratingExp, rating_val1: this.ratingInput1 })
              if (this.ratingInput2) {
                Object.assign(payload, { rating_val2: this.ratingInput2 })
              }
              payload.oem = true;
              delete payload.product_name
            }
            //check series rating
            if (this.fourKSeries) {
              selectedProcessorSeries.push("4")
              Object.assign(payload, { selected_processor_series: selectedProcessorSeries })
              payload.oem = true;
              delete payload.product_name
            }
            if (this.fiveKSeries) {
              selectedProcessorSeries.push("5")
              Object.assign(payload, { selected_processor_series: selectedProcessorSeries })
              payload.oem = true;
              delete payload.product_name
            }
            if (this.sixKSeries) {
              selectedProcessorSeries.push("6")
              Object.assign(payload, { selected_processor_series: selectedProcessorSeries })
              payload.oem = true;
              delete payload.product_name
            }
            if (this.sevenSeries) {
              selectedProcessorSeries.push("7")
              Object.assign(payload, { selected_processor_series: selectedProcessorSeries })
              payload.oem = true;
              delete payload.product_name
            }
          } else {
            payload.product_name = [];
            payload.oem = false;
          }
        }

        //add when sentiment type button is clicked on popup
        if (this.modalSentimentType) {
          Object.assign(payload, { })
        }
        
        self.$http.post(url, payload).then(
          (response) => {
            self.keywordChartData = response.body;
            self.modalLoader = false;
            self.loader = false;
            self.processChartData();
          },
          (err) => {
            self.modalLoader = false;
            self.loader = false;
          }
        )
      });
    },
    drawGaugeChart(word, positive, negative) {
      let self = this;
      let series = [];
      let value1 = Number(positive);
      let value2 = Number(negative);
      if (value1 && value2) {
        let obj = {};
        obj.name = "Positive";
        obj.color = "#1ACF85";
        obj.y = value1;
        series.push(obj);
        let obj2 = {};
        obj2.name = "Negative";
        obj2.color = "#FF786B";
        obj2.y = value2;
        series.push(obj2);
      } else {
        if (!value1) {
          let obj = {};
          obj.name = "Negative";
          obj.color = "#FF786B";
          obj.y = value2;
          series.push(obj);
          let obj2 = {};
          obj2.name = "other";
          obj2.color = "#B3B2B9";
          obj2.y = 100 - value2;
          obj2.dataLabels = { enabled: false };
          series.push(obj2);
        }
        if (!value2) {
          let obj = {};
          obj.name = "Positive";
          obj.color = "#1ACF85";
          obj.y = value1;
          series.push(obj);
          let obj2 = {};
          obj2.name = "other";
          obj2.color = "#B3B2B9";
          obj2.y = 100 - value1;
          obj2.dataLabels = { enabled: false };
          series.push(obj2);
        }
      }
      this.sentimentChart[word] = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          margin: [0, 0, 0, 0],
          padding: [0, 0, 0, 0],
          height: 110,
          width: 180,
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        tooltip: {
          formatter() {
            if (this.point.name == "other") {
              return false;
            }
            var mytooltip = "";
            mytooltip +=
              '<span style="color:' + this.point.color + '!important">\u25CF</span> ';
            mytooltip += this.point.name;
            mytooltip += " : <b> " + self.format(this.point.y) + "%</b> <br/>";
            return mytooltip;
          },
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },
        plotOptions: {
          series: {
            borderWidth: 0,
          },
          pie: {
            dataLabels: {
              enabled: true,
              distance: -15,
              format: "{point.y:.1f}",
              style: {
                fontSize: 11,
              },
              color: "black",
            },
            showInLegend: true,
            startAngle: -90,
            endAngle: 90,
            size: "100%",
            center: ["50%", "57%"],
          },
        },
        legend: {
          enabled: false,
          itemStyle: {
            fontSize: 9,
            fontWeight: 1,
          },
        },
        series: [
          {
            type: "pie",
            innerSize: "59%",
            data: series,
          },
        ],
      };
    },

    getSentiment() {
      let self = this;
      self.sentimentLoader = true;
      let payload = this.mapPayload();
      this.sentimentData = []


      const url = "/api/websites/review_sentiment";
      self.$http.post(url, payload).then(
        (response) => {
          self.sentimentData = response.body.table;
          if (this.allReviewProductsCheck || this.checkedReviewsProducts.length > 1) {
            for (let [y, td] of response.body.table.entries()) {
              for (let [y1, td1] of td.data.entries()) {
                self.drawGaugeChart(td1.word, td1.positive_score, td1.negative_score);
              }
            }
          } else {
            for (let [y, td] of response.body.table.entries()) {
              if (td.positive_score == null) {
                td.positive_score = 0;
              }
              if (td.negative_score == null) {
                td.negative_score = 0;
              }
              self.drawGaugeChart(td.word, td.positive_score, td.negative_score);
            }
          }
          this.sentimentLoader = false;
        },
        (err) => {
          self.sentimentLoader = false;
          console.log("err", err);
          this.$bvToast.toast(`Technical Error.`, {
            title: 'Weavr Sense',
            variant: 'danger',
            toaster: 'b-toaster-bottom-center',
            autoHideDelay: 3000,
          })
        }
      );
    },
    getReviewsStar() {
      let self = this;
      self.bulkLoader = true;
      let payload = this.mapPayload()

      //alert if not all or any of the products is selected
      if (!this.allReviewProductsCheck && !this.checkedReviewsProducts.length) {
        this.loader = false;
        this.$bvToast.toast(`Please select product(s) to get sentiments.`, {
          title: 'Weavr Sense',
          variant: 'danger',
          toaster: 'b-toaster-bottom-center',
          autoHideDelay: 3000,
        })
        return;
      }

      const url = "/api/websites/review_bulk";
      self.$http.post(url, payload).then(
        (response) => {
          self.bulkLoader = false;
          self.reviewStarData = response.body.data;
          if (this.allReviewProductsCheck || this.checkedReviewsProducts.length > 1) {
            for (let [idx, td] of response.body.data.entries()) {
              self.drawGaugeChart(
                td[0].processor_type,
                td[0]["rating_sentiment"].positive.per,
                td[0]["rating_sentiment"].negative.per
              );
            }
          }
        },
        (err) => {
          self.bulkLoader = false;
          console.log("err", err);
          this.$bvToast.toast(`Technical Error.`, {
            title: 'Weavr Sense',
            variant: 'danger',
            toaster: 'b-toaster-bottom-center',
            autoHideDelay: 3000,
          })
        }
      );
    },

    mapPayload() {
      let _product_name = [];

      let payload = {
        product_name: _product_name,
        channel: this.selected_website_channel_array,
        start_date: moment(this.reviewStartDate).format("YYYY-MM-DD"),
        end_date: moment(this.reviewEndDate).format("YYYY-MM-DD"),
        item_category: this.device,
        oem: false,
      };

      //modify payload all product is selected
      if (this.allReviewProductsCheck) {
        let selectedProcessorSeries = [];

        //check if any of the filters is selected
        if (this.brandFilter.length || this.cpuFilter.length || this.ratingInput1 || this.ratingInput2 || this.fourKSeries || this.fiveKSeries || this.sixKSeries || this.sevenSeries) {

          //check brand filter
          if (this.brandFilter.length) {
            Object.assign(payload, { selected_brands: this.brandFilter })
            payload.oem = true;
            delete payload.product_name
          }
          //check processor filter
          if (this.cpuFilter.length) {
            Object.assign(payload, { selected_processors: this.cpuFilter, })
            payload.oem = true;
            delete payload.product_name
          }
          //check rating 
          if (this.ratingInput1) {
            Object.assign(payload, { rating_exp: this.ratingExp, rating_val1: this.ratingInput1 })
            if (this.ratingInput2) {
              Object.assign(payload, { rating_val2: this.ratingInput2 })
            }
            payload.oem = true;
            delete payload.product_name
          }
          //check series rating
          if (this.fourKSeries) {
            selectedProcessorSeries.push("4")
            Object.assign(payload, { selected_processor_series: selectedProcessorSeries })
            payload.oem = true;
            delete payload.product_name
          }
          if (this.fiveKSeries) {
            selectedProcessorSeries.push("5")
            Object.assign(payload, { selected_processor_series: selectedProcessorSeries })
            payload.oem = true;
            delete payload.product_name
          }
          if (this.sixKSeries) {
            selectedProcessorSeries.push("6")
            Object.assign(payload, { selected_processor_series: selectedProcessorSeries })
            payload.oem = true;
            delete payload.product_name
          }
          if (this.sevenSeries) {
            selectedProcessorSeries.push("7")
            Object.assign(payload, { selected_processor_series: selectedProcessorSeries })
            payload.oem = true;
            delete payload.product_name
          }
        }
        else { //if no filter but all products are selected
          payload.oem = false;
        }

      }

      //modify payload if not all but a few of the products is selected
      if (this.checkedReviewsProducts.length && !this.allReviewProductsCheck) {
        this.checkedReviewsProducts.forEach(product => {
          _product_name.push(product);
        });
        payload['product_name'] = _product_name;
        Object.assign(payload, { oem: false })
      }

      return payload;
    },

    refreshReview() {
      let self = this;
      localStorage.reviewStartDate = this.reviewStartDate;
      localStorage.reviewEndDate = this.reviewEndDate;
      self.getReviewsStar();
      self.getSentiment();
    },
    getProducts() {
      let self = this;
      self.loader = true;
      self.productOptions = [];
      self.productOptionsFull = [];
      self.selectedProduct = {};
      const url = "/api/websites/website_products";
      let payload = {};
      payload["website"] = this.selected_website_array;
      payload["item_category"] = self.device;
      payload["start_date"] = moment(self.reviewStartDate).format("YYYY-MM-DD");
      payload["end_date"] = moment(self.reviewEndDate).format("YYYY-MM-DD");
      self.$http.post(url, payload).then(
        (response) => {
          self.loader = false;
          self.errorInProduct = false;
          if (!response.body.data.length) {
            self.errorInProduct = true;
            return;
          }
          self.productOptionsFull = response.body.data.sort();
          self.filterKeys.brand = response.body.brand_list.sort();
          self.filterKeys.processor_type = response.body.processor_list.sort();

          if (localStorage.selected_product && !self.updateSelectedProduct)
            self.selectedProduct = JSON.parse(localStorage.selected_product);
          else {
            self.selectedProduct = [];
            localStorage.selected_product = JSON.stringify(self.selectedProduct);
          }

          self.filterActions();
        },
        (err) => {
          self.loader = false;
          self.errorInProduct = true;
          this.$bvToast.toast(`Technical Error.`, {
            title: 'Weavr Sense',
            variant: 'danger',
            toaster: 'b-toaster-bottom-center',
            autoHideDelay: 3000,
          })
          console.log("err", err);
        }
      );
    },
    filterActions() {
      this.productOptions = [];
      let brandCheck = true;
      let cpuCheck = true;
      let ratingCheck = true;
      let seriesCheck = true;

      let ratingExpMapper = {
        eq: function (a, b) {
          return a == b;
        },
        gt: function (a, b) {
          return b > a;
        },
        gte: function (a, b) {
          return b >= a;
        },
        lt: function (a, b) {
          return b < a;
        },
        lte: function (a, b) {
          return b <= a;
        },
        between: function (a1, a2, b) {
          return b >= a1 && b <= a2;
        },
      };

      let processor_model_list = [];
      if (this.fourKSeries) processor_model_list.push("4");
      if (this.fiveKSeries) processor_model_list.push("5");
      if (this.sixKSeries) processor_model_list.push("6");
      if (this.sevenSeries) processor_model_list.push("7");
      for (let [ii, rr] of this.productOptionsFull.entries()) {
        if (this.brandFilter) brandCheck = this.brandFilter.includes(rr.brand_name);
        if (this.cpuFilter) cpuCheck = this.cpuFilter.includes(rr.processor_type);
        if (this.ratingExp != "between" && this.ratingInput1)
          ratingCheck = ratingExpMapper[this.ratingExp](this.ratingInput1, rr.rating);
        else if (this.ratingExp == "between" && this.ratingInput1 && this.ratingInput1)
          ratingCheck = ratingExpMapper[this.ratingExp](
            this.ratingInput1,
            this.ratingInput2,
            rr.rating
          );

        seriesCheck = processor_model_list.includes(rr.processor_model[0]);

        if (processor_model_list.length == 0)
          seriesCheck = true;
        if (this.brandFilter.length == 0) brandCheck = true;
        if (this.cpuFilter.length == 0) cpuCheck = true;


        if (brandCheck && cpuCheck && ratingCheck && seriesCheck) {
          this.productOptions.push(rr);
        }
      }
      this.refreshReview();
    },
    openGenKeywordModal(keyword, processorModel) {
      this.modalTitle = keyword;

      if (processorModel === "All Series") {
        this.processorModel = "All";
      } else {
        this.processorModel = processorModel[0];
      }

      if (!this.allReviewProductsCheck && this.checkedReviewsProducts.length > 1) {
        this.getKeywordChartData();
        this.getKeywordWiseData();
      } else {
        this.getAllKeywordData();
        this.getKeywordChartData();
      }
    },
    changeAllSentimentType(d) {
      this.$nextTick(function () {
        if(!this.allReviewProductsCheck){
          this.modalSentimentType = d;
          this.getKeywordWiseData();
        } else {
          this.allModalSentimentType = d;
          this.getAllKeywordData();
        }
      });
    },
    getAllKeywordData() {
      let self = this;
      self.modalLoader = true;
      self.loader = true;
      self.$nextTick(function () {
        self.allKeywordData = [];
        let url = "/api/reviews/keywordwise/product_detail";
        let payload = {
          keyword: this.modalTitle.toLowerCase(),
          start_date: moment(this.reviewStartDate).format("YYYY-MM-DD"),
          end_date: moment(this.reviewEndDate).format("YYYY-MM-DD"),
          channel: this.selected_website_channel_array,
          processor_model: this.processorModel,
          sentiment_type: this.allModalSentimentType,
          item_category: this.device,
          oem: false,
          product_name: this.selectedProduct
        }
        
        //modify if all product is selected
        if(this.allReviewProductsCheck){
          let selectedProcessorSeries = [];
  
          //if any of the filters is selected
          if (this.brandFilter.length || this.cpuFilter.length || this.ratingInput1 || this.ratingInput2 || this.fourKSeries || this.fiveKSeries || this.sixKSeries || this.sevenSeries) {

            //check brand filter
            if (this.brandFilter.length) {
              Object.assign(payload, { selected_brands: this.brandFilter })
              payload.oem = true;
              delete payload.product_name
            }
            //check processor filter
            if (this.cpuFilter.length) {
              Object.assign(payload, { selected_processors: this.cpuFilter, })
              payload.oem = true;
              delete payload.product_name
            }
            //check rating 
            if (this.ratingInput1) {
              Object.assign(payload, { rating_exp: this.ratingExp, rating_val1: this.ratingInput1 })
              if (this.ratingInput2) {
                Object.assign(payload, { rating_val2: this.ratingInput2 })
              }
              payload.oem = true;
              delete payload.product_name
            }
            //check series rating
            if (this.fourKSeries) {
              selectedProcessorSeries.push("4")
              Object.assign(payload, { selected_processor_series: selectedProcessorSeries })
              payload.oem = true;
              delete payload.product_name
            }
            if (this.fiveKSeries) {
              selectedProcessorSeries.push("5")
              Object.assign(payload, { selected_processor_series: selectedProcessorSeries })
              payload.oem = true;
              delete payload.product_name
            }
            if (this.sixKSeries) {
              selectedProcessorSeries.push("6")
              Object.assign(payload, { selected_processor_series: selectedProcessorSeries })
              payload.oem = true;
              delete payload.product_name
            }
            if (this.sevenSeries) {
              selectedProcessorSeries.push("7")
              Object.assign(payload, { selected_processor_series: selectedProcessorSeries })
              payload.oem = true;
              delete payload.product_name
            }
          } else {
            payload.product_name = [];
            payload.oem = false;
          }
        }

        self.$http.post(url, payload).then(
          (response) => {
            self.allKeywordData = response.body;
            self.modalLoader = false;
            self.loader = false;
            if (!self.showAllModal) self.showAllModal = true;
          },
          (err) => {
            self.modalLoader = false;
            self.loader = false;
            console.log(err);
          }
        );
      });
    },
    setSelectedWebsites(items) {
      if (items.length > 0) {
        for (let i = 0; i < items.length; i++) {
          this.modifiedSelectedWebsites.push(items[i]);
        }
      } else {
        this.modifiedSelectedWebsites.push(items);
      }
      if (localStorage.selected_websites) localStorage.selected_websites = JSON.stringify(this.modifiedSelectedWebsites);
      else localStorage.setItem("selected_websites", JSON.stringify(this.modifiedSelectedWebsites));
    },
    removeSelectedWebsites(items) {
      if (items.length > 0) {
        for (let i = 0; i < items.length; i++) {
          const itemIndex = this.selectedWebsites.findIndex(item => item.key === items[i].key);
          if (itemIndex !== -1) {
            this.selectedWebsites.splice(itemIndex, 1);
          }
        }
      } else {
        const itemIndex = this.selectedWebsites.findIndex(item => item.key === items.key);
        if (itemIndex !== -1) {
          this.selectedWebsites.splice(itemIndex, 1);
        }
      }
      this.modifiedSelectedWebsites = this.selectedWebsites;
      if (localStorage.selected_websites) localStorage.selected_websites = JSON.stringify(this.modifiedSelectedWebsites);
      else localStorage.setItem("selected_websites", JSON.stringify(this.modifiedSelectedWebsites));
    },
    clearBrandStorage() {
      this.selectedWebsites = [];
      localStorage.selected_websites = JSON.stringify(this.selectedWebsites);
    },
    format(v) {
      return this.$options.filters.format(v);
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.selectedProduct {
  background: #8e8d8d !important;
  color: White !important;
}

.cardper {
  float: right;
  position: absolute;
  right: 11px;
  bottom: 0;
  font-size: 29px;
  color: white;
}

.space-between-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 1rem;
  padding-bottom: 5px;
}

.space-between-header select {
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}

.space-between-header h3 {
  color: #4e4e4e;
  margin-bottom: 0;
  line-height: 31px;
}

.custom_dropdown {
  text-transform: uppercase;
  -youbkit-touch-callout: none;
  /* iOS Safari */
  -youbkit-user-select: none;
  /* Chrome 6.0+, Safari 3.1+, Edge & Opera 15+ */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE 10+ and Edge */
  user-select: none;
}

.custom_dropdown_wrap {
  cursor: pointer;
  display: flex;
  border: 1px solid silver;
  background: white;
  justify-content: space-between;
  padding: 7px;
  height: 30px;
}

.custom_dropdown_title {
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom_websiteMenu {
  border: 1px solid silver;
  background: white;
  width: max-content;
  position: absolute;
  z-index: 1;
  height: 300px;
  overflow-y: scroll;
  margin-left: -5px;
  border-radius: 0px 0px 5px 5px;
}

.custom_websiteMenuItems {
  font-size: 11px;
  color: var(--primary_brand);
}

.custom_optgroup {
  font-weight: bolder;
  padding-left: 9px;
  font-size: 13px;
}

.custom_option {
  padding: 8px 8px 8px 18px;
  display: flex;
  align-items: center;
  font-family: "heebo" !important;
  border-bottom: 1px solid var(--base_color-20);
}

.custom_option input {
  margin-right: 5px;
  font-size: 11px;
  accent-color: var(--primary_brand);
  width: 15px;
  height: 15px;
  font-family: "poppins";
}

.custom_option:hover {
  background: var(--base_color-10) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.custom_option.active {
  background: var(--primary_brand-60);
  color: white;
  font-weight: bolder;
}

.custom_dropdown {
  text-transform: uppercase;
  -youbkit-touch-callout: none;
  /* iOS Safari */
  -youbkit-user-select: none;
  /* Chrome 6.0+, Safari 3.1+, Edge & Opera 15+ */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE 10+ and Edge */
  user-select: none;
}

.customselect {
  height: 34px;
  border-radius: 0;
  background: white;
  border: 1px solid silver;
  padding-left: 11px;
  padding-right: 11px;
  margin-right: 5px;
}

.eachProduct:hover {
  background: #d4d4d4;
}

.productListCheckbox {
  display: flex;
  align-items: center;
}

.productListCheckbox input {
  /* font-size: 11px !important; */
  accent-color: var(--primary_brand);
  width: 16px !important;
  height: 16px !important;
}

.productListCheckbox input[type="checkbox"] {
  border: 1px solid var(--primary_brand) !important;
}

.productListCheckbox span {
  margin-left: 10px;
  /* font-weight: 600; */
  font-family: "Poppins", sans-serif !important;
}

/* revamp */
#sentiments_amd {
  font-family: "Poppins", sans-serif !important;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

.custom_dropdown {
  text-transform: uppercase;
  -youbkit-touch-callout: none;
  /* iOS Safari */
  -youbkit-user-select: none;
  /* Chrome 6.0+, Safari 3.1+, Edge & Opera 15+ */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE 10+ and Edge */
  user-select: none;
}

.datebox {
  width: 14% !important;
}

.custom_dropdown_wrap {
  cursor: pointer;
  display: flex;
  border: 1px solid silver;
  background: white;
  justify-content: space-between;
  padding: 7px;
  height: 30px;
}

.custom_dropdown_title {
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* select  */
select {
  font-family: "Poppins", sans-serif;
}

.customSelect:focus {
  background: var(--base_color-5) !important;
  color: var(--primary_brand-60) !important;
  border: 1px solid var(--primary_brand-60) !important;
  outline: none !important;
  box-shadow: none !important;
  font-weight: 600 !important;
}

.separated-card:nth-child(odd) {
  margin-right: 1%;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

.backIcon {
  filter: brightness(0) saturate(100%) invert(98%) sepia(0%) saturate(206%) hue-rotate(268deg) brightness(116%) contrast(100%);
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  margin-bottom: -20px !important;
}

button.success {
  background: var(--green);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 16px;
}

button.danger {
  background: var(--red);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 16px;
}

table {
  --border: 1px solid var(--base_color-20);
  border-radius: 10px;
  border-spacing: 0;
  border-collapse: separate;
  border: var(--border);
  overflow: hidden;
}

table th:not(:last-child),
table td:not(:last-child) {
  border-right: var(--border) !important;
}

table>thead>tr:not(:last-child)>th,
table>thead>tr:not(:last-child)>td,
table>tbody>tr:not(:last-child)>th,
table>tbody>tr:not(:last-child)>td,
table>tfoot>tr:not(:last-child)>th,
table>tfoot>tr:not(:last-child)>td,
table>tr:not(:last-child)>td,
table>tr:not(:last-child)>th,
table>thead:not(:last-child),
table>tbody:not(:last-child),
table>tfoot:not(:last-child) {
  border-bottom: var(--border) !important;
}

table th {
  background: var(--background);
  padding: 0.6rem !important;
  font-size: 14px !important;
  font-family: "Poppins", sans-serif !important;
}

table td {
  padding: 4px !important;
  font-size: 13px !important;
  font-family: "Heebo", sans-serif !important;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}

.searchInput input {
  height: 35px !important;
  margin-right: -5px !important;
  font-size: 14px !important;
  border-color: var(--primary_brand-60) !important;
  font-family: "poppins";
}

.searchInput input::placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input:focus {
  box-shadow: none !important;
  border-color: var(--primary_brand) !important;
  font-family: "poppins";
}

.searchIcon {
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  font-family: "poppins";
  background-color: var(--primary_brand);
}

.searchIcon img {
  width: 25px;
  margin: 10px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

.inputBoxTitle {
  color: var(--primary_brand);
  font-size: 16px;
  margin-bottom: 5px;
  font-family: "poppins";
}

.modalSelect {
  margin-bottom: 6px !important;
}

.checkbox-btn {
  margin-right: 6px;
  height: 35px !important;
  display: flex;
  align-items: center;
  border: none;
  background-color: var(--base_color-10);
  border-radius: 5px;
  color: #000;
  padding: 0px 10px;
  font-family: "poppins";
}

.checkbox-btn span {
  padding: 0 5px;
  margin-left: 10px;
  font-family: "poppins";
}

.checkbox-btn input {
  margin: 4px;
  font-size: 11px;
  accent-color: #fff;
  width: 15px;
  height: 15px;
  font-family: "poppins";
}

.productListCheckbox {
  display: flex;
  align-items: center;
}

.productListCheckbox input {
  font-size: 11px !important;
  accent-color: var(--primary_brand);
  width: 15px !important;
  height: 15px !important;
}

.productListCheckbox input[type="checkbox"] {
  border: 1px solid var(--primary_brand) !important;
}

.productListCheckbox span {
  margin-left: 10px;
  /* font-weight: 600; */
  font-family: "Poppins", sans-serif !important;
}

.eachProduct:hover {
  background: var(--base_color-20);
}

.productScroll {
  padding-top: 0px;
  cursor: pointer;
  height: 300px;
  overflow-y: scroll;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: var(--base_color-10);
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}

.inputBoxTitle {
  color: var(--primary_brand);
  font-size: 16px;
  margin-bottom: 5px;
  font-family: "poppins";
}

.ratingSection {
  display: flex;
  justify-content: start;
  padding-right: 15px;
  padding-left: 15px;
  width: 100%;
}

.ratingSectionItem {
  width: 25%;
}

.each-review {
  padding: 8px !important;
  background: none !important;
  margin-bottom: 3px !important;
  border-radius: 10px !important;
  margin-right: 2px !important;
  font-family: "Heebo", sans-serif !important;
}

.each-review:not(:first-child) {
  padding-top: 2px !important;
}

.usericon {
  background: var(--primary_brand-80);
  border-radius: 0.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.2rem;
}

.usericon img {
  filter: brightness(0) saturate(100%) invert(97%) sepia(3%) saturate(6%) hue-rotate(183deg) brightness(116%) contrast(100%);
  height: 15px;
}

.username {
  font-family: "Heebo", sans-serif;
  font-size: 15px;
  letter-spacing: 0.6px;
  color: var(--primary_brand);
  font-weight: 600;
  text-transform: capitalize;
}

.usertimestamp {
  font-family: "Heebo", sans-serif;
  font-size: 12px;
  letter-spacing: 0.6px;
  color: var(--base_color-60);
  font-weight: 600;
  margin-left: 12px;
  padding-top: 4px;
}

.helpful {
  float: right;
  display: inline-block;
  font-family: "Heebo", sans-serif;
  font-size: 12px;
  letter-spacing: 0.6px;
  color: var(--base_color-60);
  font-weight: 600;
  text-transform: capitalize;
  padding: 4px;
}

.usertext {
  display: inline-block;
  width: 100%;
  font-family: "Heebo", sans-serif;
  font-size: 14px !important;
}
</style>
<style lang="scss">
.modal-title {
  font-weight: 600 !important;
  font-family: "poppins";
}

.modal-header {
  background: var(--primary_brand-20) !important;
  color: var(--base_color);
  border: none;
  display: flex !important;
  justify-content: start !important;
  padding-bottom: 1rem !important;
  font-family: "poppins";
}

.modal-header .close {
  color: black;
  text-shadow: none;
  position: absolute;
  top: -2px;
  right: -6px;
  font-size: 30px;
  background: var(--primary_brand-10);
  opacity: inherit;
  padding: 5px 10px;
  border-radius: 25px;
}

.borderBetween {
  border-bottom: 0.13rem solid #e1e1e1 !important;
  margin: 10px 0px 20px !important;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show>.btn-outline-secondary.dropdown-toggle {
  color: #ffffff !important;
  background-color: var(--primary_brand-80) !important;
  border-color: var(--primary_brand-80) !important;
  line-height: 35px !important;
  padding: 0px 20px !important;
  border-radius: 5px !important;
  font-weight: 600 !important;
}

.btn-outline-secondary {
  line-height: 35px !important;
  /* border-radius: 5px; */
  color: var(--primary_brand) !important;
  background: var(--primary_brand-10) !important;
  border: 1px solid var(--primary_brand-10) !important;
  font-family: "poppins" !important;
  padding: 0px 20px !important;
}

.btn-group {
  background: var(--primary_brand-10) !important;
  border-radius: 5px !important;
  font-family: "poppins" !important;

  /* border: 1px solid var(--primary_brand-10); */
}

.datePickerBadge {
  margin-left: 6px;
  height: 35px !important;
  border: 1px solid #c5c5c5;
  border-right: none;
  display: flex;
  align-items: center;
  margin-right: -5px;
  z-index: 3;
  background: #fff;
  color: black;
  border-radius: 5px 0px 0px 5px;
  font-family: "poppins";
}
</style>
<style>
.customMultiselect .multiselect__placeholder {
  margin-bottom: 6px !important;
  padding: 0px !important;
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tags {
  border: 1px solid var(--base_color-40) !important;
  padding-top: 6px !important;
  min-height: 35px !important;
  max-height: 36px !important;
  overflow-y: auto;
  font-family: "poppins";
}

.customMultiselect .multiselect__input {
  border: var(--base_color-20) !important;
  height: 30px !important;
}

.customMultiselect .multiselect__input:focus {
  outline: none !important;
}

.customMultiselect .multiselect__select {
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
  top: 56% !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag {
  background: var(--primary_brand-80) !important;
  margin-bottom: 0px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
  color: #fff !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
  border: 1px solid var(--base_color-40) !important;
  border-top: none !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__option--selected.multiselect__option--highlight {
  background: var(--red) !important;
  color: var(--white) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
  background: var(--base_color-20) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__element {
  color: var(--primary_brand-80) !important;
  border-bottom: 1px solid var(--base_color-20);
  font-family: "poppins";
}

.customMultiselect .multiselect__option--group {
  background-color: #44777A !important;
  color: white !important;
  font-size: 16px;
}

.customMultiselect .multiselect__option--highlight::after {
  font-size: 10px !important;
  padding-inline: 6px !important;
}

/* width */
.customMultiselect ::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
  background: var(--base_color-20);
  border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}
</style>
